module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external "underscore"
// module id = 5
// module chunks = 0 1 2 3